import React, { useEffect } from 'react'
import { setGlobalLoader } from '../../../redux/slices/globalLoader';
import { useDispatch, useSelector } from 'react-redux';
import GlobalLoader from '../shared/globalLoader';

const Errror = () => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);

    useEffect(() => {
        Promise.all([import('rsuite/dist/rsuite.min.css'),
        import('bootstrap/dist/css/bootstrap.min.css'),
        import("../../../assets/admin/css/skins.css"),
        import("../../../assets/admin/css/icon-list.css"),
        import("../../../assets/admin/plugins/select2/css/select2.min.css"),
        import("../../../assets/admin/css/style.css"),
        import("../../../assets/admin/css/dark-style.css"),
        import("../../../assets/admin/css/colors/default.css"),
        import("../../../assets/admin/plugins/multipleselect/multiple-select.css"),
        import("../../../assets/admin/css/sidemenu/sidemenu.css"),
        import("../../../assets/admin/plugins/summernote/summernote-bs4.css"),
        import("../../../assets/admin/plugins/fileuploads/css/fileupload.css"),
        import("../../../assets/admin/plugins/fancyuploder/fancy_fileupload.css")]).then(() => {
            dispatch(setGlobalLoader(false));
        });
    }, []);

// return (
//     loaderState ?
//         <GlobalLoader /> :
//         <div
//             style={{
//                 height: "100vh",
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 background: "linear-gradient(135deg, #2f7f7b, #3fa9a3)",
//                 fontFamily: "sans-serif",
//                 position: "relative",
//                 overflow: "hidden"
//             }}
//         >
//             {/* Glow Effect */}
//             <div
//                 style={{
//                     position: "absolute",
//                     width: "500px",
//                     height: "500px",
//                     background: "#49c5b6",
//                     filter: "blur(140px)",
//                     opacity: 0.4,
//                     top: "-100px",
//                     right: "-100px"
//                 }}
//             />

//             <div
//                 className="text-center"
//                 style={{
//                     color: "#fff",
//                     padding: "45px",
//                     borderRadius: "18px",
//                     backdropFilter: "blur(14px)",
//                     background: "rgba(255,255,255,0.08)",
//                     boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
//                     zIndex: 2
//                 }}
//             >
//                 {/* 404 */}
//                 <h1
//                     style={{
//                         fontSize: "120px",
//                         fontWeight: "900",
//                         margin: 0,
//                         letterSpacing: "5px"
//                     }}
//                 >
//                     404
//                 </h1>

//                 {/* Title */}
//                 <h2 style={{ marginTop: "10px", fontWeight: "600" }}>
//                     Page Not Found
//                 </h2>

//                 {/* Description */}
//                 <p
//                     style={{
//                         maxWidth: "420px",
//                         margin: "10px auto",
//                         opacity: 0.85
//                     }}
//                 >
//                     The page you're looking for doesn’t exist or has been moved.
//                 </p>

//                 {/* Button */}
//                 <a
//                     href="/admin/dashboard"
//                     style={{
//                         display: "inline-block",
//                         marginTop: "20px",
//                         padding: "12px 30px",
//                         borderRadius: "30px",
//                         background: "#ffffff",
//                         color: "#2f7f7b",
//                         fontWeight: "600",
//                         textDecoration: "none",
//                         transition: "all 0.3s ease"
//                     }}
//                     onMouseOver={(e) => {
//                         e.target.style.transform = "scale(1.08)";
//                         e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.2)";
//                     }}
//                     onMouseOut={(e) => {
//                         e.target.style.transform = "scale(1)";
//                         e.target.style.boxShadow = "none";
//                     }}
//                 >
//                     Back to Home
//                 </a>
//             </div>
//         </div>
// )

return (
    loaderState ?
        <GlobalLoader /> :
        <div
            style={{
                height: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                // ✅ SAME COLOR FAMILY BUT LIGHTER
                background: "linear-gradient(135deg, #4fa39f, #6fc9c3)",

                fontFamily: "sans-serif",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* Glow Effect (slightly softer) */}
            <div
                style={{
                    position: "absolute",
                    width: "500px",
                    height: "500px",
                    background: "#7fdad3",
                    filter: "blur(140px)",
                    opacity: 0.35,
                    top: "-100px",
                    right: "-100px"
                }}
            />

            {/* ✅ SAME CARD (UNCHANGED) */}
            <div
                className="text-center"
                style={{
                    color: "#fff",
                    padding: "45px",
                    borderRadius: "18px",
                    backdropFilter: "blur(14px)",
                    background: "rgba(255,255,255,0.08)",
                    boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
                    zIndex: 2
                }}
            >
                <h1
                    style={{
                        fontSize: "120px",
                        fontWeight: "900",
                        margin: 0,
                        letterSpacing: "5px"
                    }}
                >
                    404
                </h1>

                <h2 style={{ marginTop: "10px", fontWeight: "600" }}>
                    Page Not Found
                </h2>

                <p
                    style={{
                        maxWidth: "420px",
                        margin: "10px auto",
                        opacity: 0.85
                    }}
                >
                    The page you're looking for doesn’t exist or has been moved.
                </p>

                <a
                    href="/admin/dashboard"
                    style={{
                        display: "inline-block",
                        marginTop: "20px",
                        padding: "12px 30px",
                        borderRadius: "30px",
                        background: "#ffffff",
                        color: "#2f7f7b",
                        fontWeight: "600",
                        textDecoration: "none",
                        transition: "all 0.3s ease"
                    }}
                    onMouseOver={(e) => {
                        e.target.style.transform = "scale(1.08)";
                        e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.2)";
                    }}
                    onMouseOut={(e) => {
                        e.target.style.transform = "scale(1)";
                        e.target.style.boxShadow = "none";
                    }}
                >
                    Back to Home
                </a>
            </div>
        </div>
)

}

export default Errror